import axios from "axios";
import {  UserProfileToken } from "../types/User.type";
import {handleError} from "../utils/ErrorHandler.tsx"
import { getServerUrl } from './getServerUrl';

const rootURL = getServerUrl()
const URL = rootURL+"/auth";

export async function loginApi(username: string, password: string) {
  try{
    const data = await axios.post<UserProfileToken>(URL + "/login", {
      username: username,
      password: password,
    });
    return data;
  } catch(error){
    handleError(error)
  }
}

export async function registerApi(email: string, username: string, password: string) {
  try{
    const data = await axios.post<UserProfileToken>(URL + "/signup", {
        username: username,
        password: password,
        email: email
      });
      return data;
    } catch(error){
      handleError(error)
    }
}


